import { Solicitud } from '../../../../classes/Solicitud';
import Accordion from '../../../../components/Accordion';
import { useEffect, useState } from 'react';
import { useSolicitud } from '../../../../hooks/useSolicitud';
import Table, {
  ColumnDefinitionType,
} from '../../../../components/Table';
import { Loading } from '../../../../components/Loading';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../app/store';
import { downloadAndOpenQR } from '../../../../services/Service';
import { useSolicitudPermissions } from '../../../../hooks/useSolicitudPermissions';
import MyModal from '../../../../components/Modal';
import { APROBADA_STATUS_ID } from '../../../../constants/constants';

// Componente separado para manejar los permisos de cada fila
const ActionCell = ({
  data,
  permisos,
  handleUrlVolver,
}: {
  data: Solicitud;
  permisos: string[];
  handleUrlVolver: (url: string) => void;
}) => {
  // Usar el hook unificado de permisos
  const { canEditWithProfiles } = useSolicitudPermissions({
    solicitudEstadoId: data.idTipoEstado,
  });

  const puedeEditar = canEditWithProfiles;

  return (
    <>
      {permisos.find((nombre) => nombre === 'VISTA_SOLICITUD') !==
        undefined && (
        <Link
          to={`/solicitud/${data.id}?action=view`}
          title="Visualizar"
          onClick={(e) => {
            e.stopPropagation();
            handleUrlVolver('/bandejaTrabajo');
          }}
        >
          <i
            className="fa fa-eye text-secondary me-2"
            aria-hidden="true"
          ></i>
        </Link>
      )}
      {puedeEditar &&
        permisos.find((nombre) => nombre === 'EDICION_SOLICITUD') !==
          undefined && (
          <Link
            to={`/solicitud/${data.id}?action=edit`}
            title="Editar"
            onClick={(e) => {
              e.stopPropagation();
              handleUrlVolver('/bandejaTrabajo');
            }}
          >
            <i
              className="fa fa-pencil text-secondary"
              aria-hidden="true"
            ></i>
          </Link>
        )}
      {permisos.find((nombre) => nombre === 'CONSULTA_SOLICITUD') !==
        undefined && (
        <Link
          to={'#'}
          title="QR"
          onClick={(e) => {
            e.stopPropagation();
            downloadAndOpenQR(`/solicitudes/${data.id}/QRCode`);
          }}
        >
          <i
            className="fa fa-qrcode fa-lg mx-1 text-success"
            aria-hidden="true"
          ></i>
        </Link>
      )}
    </>
  );
};

export const TablaBandeja = () => {
  const { permisos } = useSelector((state: RootState) => state.auth);
  const { usuarioLogin } = useSelector(
    (state: RootState) => state.auth
  );
  const {
    solicitudes,
    handleLoading,
    bandejaTrabajo,
    loading,
    handleUrlVolver,
    esConAnalisisRiesgo,
  } = useSolicitud();

  const [showDDJJModal, setShowDDJJModal] = useState(false);
  const [solicitudesPendientesDDJJ, setSolicitudesPendientesDDJJ] =
    useState<Solicitud[]>([]);

  useEffect(() => {
    handleLoading(true);
    bandejaTrabajo();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Validación de DDJJ pendientes para contratistas con análisis de riesgo
  useEffect(() => {
    const validarDDJJPendientes = async () => {
      // Verificar si el modal ya fue mostrado en esta sesión (persiste entre navegaciones)
      const modalYaMostrado = sessionStorage.getItem(
        'ddjjModalMostrado'
      );
      if (modalYaMostrado === 'true') {
        return;
      }

      // Verificar si el usuario es contratista
      if (usuarioLogin.tipoUsuarioValor !== 'CONTRATISTA') {
        return;
      }

      // Verificar si hay solicitudes cargadas
      if (!solicitudes || solicitudes.length === 0) {
        return;
      }

      // Verificar si la empresa gestora es con análisis de riesgo
      // if (usuarioLogin.idEmpresaGestora) {
      //   const conAnalisisRiesgo = await esConAnalisisRiesgo(
      //     usuarioLogin.idEmpresaGestora
      //   );

      //if (conAnalisisRiesgo) {
      // Filtrar solicitudes aprobadas sin aceptación de DDJJ
      // logger.log('Con análisis de riesgo:', conAnalisisRiesgo);
      const solicitudesSinDDJJ = solicitudes.filter(
        (solicitud) =>
          solicitud.idTipoEstado === APROBADA_STATUS_ID &&
          (solicitud.aceptacionInt === null ||
            solicitud.aceptacionInt === 0) &&
          solicitud.conAnalisisRiesgo === 1
      );

      if (solicitudesSinDDJJ.length > 0) {
        setSolicitudesPendientesDDJJ(solicitudesSinDDJJ);
        setShowDDJJModal(true);
        // Marcar en sessionStorage que el modal ya fue mostrado (persiste durante la sesión)
        sessionStorage.setItem('ddjjModalMostrado', 'true');
      }
      // }
      //}
    };

    if (!loading) {
      validarDDJJPendientes();
    }
  }, [solicitudes, loading, usuarioLogin, esConAnalisisRiesgo]);

  const toggleDDJJModal = () => {
    setShowDDJJModal(!showDDJJModal);
  };

  let columns: ColumnDefinitionType<Solicitud, keyof Solicitud>[] = [
    {
      key: 'numeroSolicitud',
      header: 'Número de Solicitud',
    },
    {
      key: 'tipoTrabajo',
      header: 'Tipo de Trabajo',
    },

    {
      key: 'estado',
      header: 'Estado',
    },

    {
      key: 'empresaGestora',
      header: 'Empresa Gestora',
    },
    {
      key: 'instalacion',
      header: 'Instalacion',
    },
    {
      key: 'contratista',
      header: 'Contratista',
    },

    {
      key: 'id',
      header: 'Acciones',
      cell: (data: Solicitud) => (
        <ActionCell
          data={data}
          permisos={permisos}
          handleUrlVolver={handleUrlVolver}
        />
      ),
    },
  ];
  if (
    permisos.find((nombre) => nombre === 'VISTA_SOLICITUD') ===
      undefined &&
    permisos.find((nombre) => nombre === 'EDICION_SOLICITUD') ===
      undefined
  ) {
    columns = columns.filter((c) => c.key !== 'id');
  }

  return (
    <>
      {/* <MyModal isOpen={isOpen} toggle={toggle} title='Crear Solicitud' secondButton={true} secondButtonTitle="Aceptar" titleCancelar="Cancelar" size="lg">
                <CrearSolicitud />
            </MyModal> */}
      <Accordion
        id={'accordionSolicitudBandejaListado'}
        title="Bandeja de Trabajo"
        iconoClass="fa fa-search mr-1"
      >
        <div className="table-responsive ">
          {loading ? (
            <Loading />
          ) : (
            solicitudes && (
              <Table
                data={solicitudes || []}
                columns={columns}
                notResults="No existen solicitudes para el criterio ingresado"
              ></Table>
            )
          )}
        </div>
      </Accordion>

      {/* Modal para alertar sobre DDJJ pendientes */}
      <MyModal
        isOpen={showDDJJModal}
        toggle={toggleDDJJModal}
        title="Declaraciones Juradas Pendientes"
        titleCancelar="Cerrar"
        size="lg"
        enabledFooter={true}
        cancelButton={true}
      >
        <div className="alert alert-warning" role="alert">
          <i
            className="fa fa-exclamation-triangle me-2"
            aria-hidden="true"
          ></i>
          Las siguientes solicitudes están <strong>APROBADAS</strong>{' '}
          pero requieren la aceptación de la Declaración Jurada:
        </div>
        <div className="table-responsive">
          <table className="table table-striped">
            <thead>
              <tr>
                <th>Número de Solicitud</th>
                <th>Tipo de Trabajo</th>
                <th>Empresa Gestora</th>
                <th>Acción</th>
              </tr>
            </thead>
            <tbody>
              {solicitudesPendientesDDJJ.map((solicitud) => (
                <tr key={solicitud.id}>
                  <td>{solicitud.numeroSolicitud}</td>
                  <td>{solicitud.tipoTrabajo}</td>
                  <td>{solicitud.empresaGestora}</td>
                  <td>
                    <Link
                      to={`/solicitud/${solicitud.id}?action=edit`}
                      className="btn btn-sm btn-primary"
                      onClick={() => {
                        handleUrlVolver('/bandejaTrabajo');
                        toggleDDJJModal();
                      }}
                    >
                      <i
                        className="fa fa-edit me-1"
                        aria-hidden="true"
                      ></i>
                      Aceptar DDJJ
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </MyModal>
    </>
  );
};
